export default {
    BASE_URL : "https://api.str-ing.org/wp-json/wp/v2/",
    BASE_URL2 : "https://api.str-ing.org/wp-json/cm/",
    WP_URL : "https://api.str-ing.org/",
    CATEGORY_ID : 29,
    INTRO_URL: "intro"
}
